import axios from "axios";
import { API_CONFIG } from "../config/constants";

export const API_BASE_URL = API_CONFIG.BASE_API;

export const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const api = axios.create({
  baseURL: API_CONFIG.BASE_API,
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authAPI = {
  /**
   * Inicia sesión de usuario
   * @param {string} email - Email del usuario
   * @param {string} password - Contraseña del usuario
   * @returns {Promise<Object>} Datos de usuario y token
   */
  login: async (email, password) => {
    try {
      console.log("Haciendo petición de login a:", `${API_CONFIG.BASE_API}/auth/login`);

      const response = await api.post("/auth/login", { email, password });
      console.log("<SquareCheckBig /> Respuesta de login exitosa:", response.data);

      return { success: true, data: response.data };
    } catch (error) {
      console.error("❌ Error en login API:", error);
      console.error("❌ Response data:", error.response?.data);
      console.error("❌ Status:", error.response?.status);

      return {
        success: false,
        error: error.response?.data?.detail || "Error de login",
      };
    }
  },

  register: async (userData) => {
    try {
      const response = await api.post("/auth/register", userData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || "Error de registro",
      };
    }
  },

  getProfile: async () => {
    const response = await api.get("/auth/me");
    return response.data;
  },
};

export const categoriesAPI = {
  getAll: async () => {
    const response = await api.get("/categories");
    return response.data;
  },

  getBySlug: async (categorySlug) => {
    const response = await api.get(`/categories/${categorySlug}`);
    return response.data;
  },

  getTramites: async (categorySlug) => {
    const response = await api.get(`/categories/${categorySlug}/applications`);
    return response.data;
  },
};

export const dashboardAPI = {
  getStats: async () => {
    const response = await api.get("/dashboard/stats");
    return response.data;
  },

  getTramiteRequests: async () => {
    const response = await api.get("/applications/requests");
    return response.data;
  },
};
